import ProfileAvatar from 'src/shared/features/users/components/profile-photos/profile-avatar'

const ChatAvatar = ({
  isConsumerChat,
  initials,
  userId,
  size,
}: {
  isConsumerChat: boolean
  initials: string
  userId: number
  size: number
}) => {
  return !userId ? (
    <div
      className="flex items-center justify-center rounded-full bg-muted font-semibold text-white"
      style={{ width: size + 5, height: size + 5, fontSize: size / 2 - 5 }}
    >
      ??
    </div>
  ) : isConsumerChat ? (
    <div
      className="flex items-center justify-center rounded-full bg-muted font-semibold text-white"
      style={{ width: size + 5, height: size + 5, fontSize: size / 2 - 5 }}
    >
      {!userId ? '??' : initials}
    </div>
  ) : (
    <div className="w-fit rounded-full border-[2.5px] border-white bg-white shadow-[0_0_10px_0_rgba(27,48,41,0.2)]">
      <ProfileAvatar userId={userId} size={size} />
    </div>
  )
}

export default ChatAvatar
